import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const BRAND_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Brand.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const BRAND_CONFIG = {
  entityName: 'Brand',
  localizationKey: 'General::Entity.Brand',
  fields: BRAND_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Brands',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
